import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SiteConfig } from "../features/config/configApiSlice";
import { add } from "date-fns";
import { AlertLevel } from "../components/AlertMessage";

export interface SharedAlert {
	level: AlertLevel;
	message: string;
	showIcon?: boolean;
}

export interface SiteState {
	aspUrl: string;
	config: SiteConfig | null;
	sharedAlert: SharedAlert | null;
}

const initialState: SiteState = {
	aspUrl: `https://localhost/miwrite`,
	config: null,
	sharedAlert: null,
};

export const siteSlice = createSlice({
	name: "site",
	initialState,
	reducers: {
		setAspUrl(state, action: PayloadAction<string>) {
			state.aspUrl = action.payload;
		},
		setSiteConfig(state, action: PayloadAction<SiteConfig>) {
			state.config = {
				...action.payload,
				expirationDate: add(Date.now(), { hours: 8 }).getTime(),
			};
		},
		setSharedAlert(state, action: PayloadAction<SharedAlert>) {
			state.sharedAlert = action.payload;
		},
		clearSharedAlert(state) {
			state.sharedAlert = null;
		},
	},
});

export const { setAspUrl, setSiteConfig, setSharedAlert, clearSharedAlert } = siteSlice.actions;

export default siteSlice.reducer;
